import { render, staticRenderFns } from "./WholeSchoolMoveForm.vue?vue&type=template&id=d698003c"
import script from "./WholeSchoolMoveForm.vue?vue&type=script&lang=js"
export * from "./WholeSchoolMoveForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports